import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=6895c966&scoped=true"
var script = {}
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=6895c966&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6895c966",
  null
  
)

export default component.exports